import { Helmet } from "react-helmet-async"
import { useEffect, useState } from "react"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../../components/ui/carousel"
import { DoctorCard } from "../../components/doctor-card"
import OurDoctorswidget from "../../components/widgets/ourdoctors"
import { Badge } from "../../components/ui/badge"
import SEO from "../SEO"

export default function Leadership() {
 const leadershipSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://pranaamhospitals.com/#organization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaamhospitals.com/",
    "logo": "https://pranaamhospitals.com/images/pranaam-logo.png",
    "description": "Meet the experienced doctors and leadership team at Pranaam Hospitals. Our expert specialists are dedicated to delivering compassionate, advanced, and patient-focused healthcare in Hyderabad.",
    "sameAs": [
      "https://www.facebook.com/pranaamhospitals",
      "https://www.instagram.com/pranaamhospitals",
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://pranaamhospitals.com/leadership#breadcrumb",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://pranaamhospitals.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Leadership",
        "item": "https://pranaamhospitals.com/leadership"
      }
    ]
  }
];

const [seo, setSeo] = useState({});
  const [pageKeywords, setPageKeywords] = useState("");
const [pageData, setPageData] = useState(null);
useEffect(() => {
  fetch("/wp-json/custom/v1/page-seo?slug=leadership")
  .then(res => res.json())
  .then(data => { if (data?.seo) setSeo(data.seo); setPageKeywords(data?.keywords || ""); })
  .catch(() => {});
}, []);
 
 
  return (
    <>
      <SEO
        title={seo.title || "Leadership | Pranaam Hospitals"}
        description={seo.description || "Meet the visionary leadership team of Pranaam Hospitals driving excellence in healthcare, innovation, and patient-centered medical services in Hyderabad."}
        canonical={seo.canonical || "https://pranaamhospitals.com/leadership"}
        robots={Array.isArray(seo.robots) ? seo.robots.join(", ") : seo.robots || "index, follow"}
        keywords={pageKeywords}
        ogTitle={seo.og_title}
        ogDescription={seo.og_description}
        ogImage={seo.og_image || seo.featured_image}
        twitterTitle={seo.twitter_title}
        twitterDescription={seo.twitter_description}
        author="Pranaam Hospitals"
        publisher="Pranaam Hospitals"
        schema={leadershipSchema}
      />
     
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
         <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Our Leadership</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                Meet Our <span className="text-primary">Leaders</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Visionary healthcare professionals dedicated to excellence, innovation, and compassionate patient care.
              </p>
            </div>
          </div>
        </section>
 
        {/* <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto">
                Our leadership team brings together decades of experience in healthcare, management, and innovation to guide Pranaam Hospitals towards excellence.
              </p>
            </div>
 
            <Carousel className="w-full max-w-5xl mx-auto">
              <CarouselContent>
                {doctors.length > 0 ? (
                  doctors.map((doctor) => {
                    if (!doctor) return null
                    const name = doctor?.title?.rendered || "No name"
                    const specialty = doctor?.acf?.expertised_area || "Specialty not available"
                    const experience = doctor?.acf?.latest_achievement || doctor?.excerpt?.rendered || ""
                    const image =
                      doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                      doctor.featured_media_url ||
                      "/placeholder.svg?height=300&width=300&text=Doctor"
 
                    return (
                      <CarouselItem key={doctor.id} className="md:basis-1/2 lg:basis-1/3">
                        <DoctorCard
                          name={name}
                          specialty={specialty}
                          experience={experience}
                          image={image}
                          slug={doctor.slug}
                        />
                      </CarouselItem>
                    )
                  })
                ) : (
                  <p className="text-center w-full py-6">Loading doctors...</p>
                )}
              </CarouselContent>
 
              <div className="flex justify-center mt-8">
                <CarouselPrevious className="relative mr-2 left-0" />
                <CarouselNext className="relative ml-2 right-0" />
              </div>
            </Carousel>
          </div>
        </div> */}
        <OurDoctorswidget />;
      </main>
    </>
  )
}